// ! --- Sitemap Generator Configuration ---
export const BASE_URL = 'https://beta.kenogo.com.au/'; // !Please ensure this has the prod host
export const DEFAULT_CHANGE_FREQ = 'weekly'; // TODO: Define default change frequency for pages as fallback
export const DEFAULT_PRIORITY = 0.7; // TODO: Define default priority for pages as fallback
